/**
 * @fileoverview Loads a city's currency and power bank hold default once and
 * shares them with every client section on the pickup page.
 */
import React, { createContext, useContext, useMemo } from 'react'
import PropTypes from 'prop-types'

import { useCityCurrency, usePowerBankHoldSetting } from './hooks'

const PowerBankCityContext = createContext({
  money: { currencySign: null, currency: null },
  setting: { holdRequired: false, holdAmount: 0, currency: null },
  loading: false,
  settingError: null,
})

export const PowerBankCityProvider = ({ cityId, children }) => {
  const { money, loading: moneyLoading } = useCityCurrency(cityId)
  const {
    setting,
    loading: settingLoading,
    error: settingError,
  } = usePowerBankHoldSetting(cityId)

  const value = useMemo(
    () => ({
      money,
      setting,
      loading: moneyLoading || settingLoading,
      settingError,
    }),
    [money, setting, moneyLoading, settingLoading, settingError],
  )

  return (
    <PowerBankCityContext.Provider value={value}>
      {children}
    </PowerBankCityContext.Provider>
  )
}

PowerBankCityProvider.propTypes = {
  cityId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
}

export const usePowerBankCity = () => useContext(PowerBankCityContext)
